// Create a new file for the component
import React from 'react'

import { LineChartData } from '../../../types/Dashboard/types'

interface ResponsiveLineChartDotProps {
  data: LineChartData
  index: number
  lineDot: React.ReactElement | null
  payload: {
    date: number
    [key: string]: number | null
  }
  cx?: number
  cy?: number
  dataKey: string
}

export const ResponsiveLineChartDot = ({
  cx,
  cy,
  data,
  dataKey,
  index,
  lineDot,
  payload,
}: ResponsiveLineChartDotProps) => {
  if (data && index === data.length - 1 && lineDot) {
    if (!dataKey.startsWith('Estimated') && !data.some(point => point[`Estimated ${dataKey}`] !== undefined)) {
      return React.cloneElement(lineDot as React.ReactElement<{ cx?: number; cy?: number; className?: string }>, {
        className: 'opacity-0 transition-opacity duration-300 animate-[fadeIn_0.2s_ease-in-out_forwards]',
        cx,
        cy,
      })
    }

    const isEstimated = dataKey.startsWith('Estimated')
    const baseKey = isEstimated ? dataKey.replace('Estimated ', '') : dataKey
    const estimatedKey = isEstimated ? dataKey : `Estimated ${dataKey}`

    const lastActualPoint = data.find(point => point[baseKey] !== null && point[estimatedKey] !== null)

    const isTransitionOrAfter = lastActualPoint?.date ? payload.date >= lastActualPoint.date : false

    if ((isEstimated && isTransitionOrAfter) || (!isEstimated && !isTransitionOrAfter)) {
      return React.cloneElement(lineDot as React.ReactElement<{ cx?: number; cy?: number; className?: string }>, {
        className: 'opacity-0 transition-opacity duration-300 animate-[fadeIn_0.2s_ease-in-out_forwards]',
        cx,
        cy,
      })
    }
  }

  return <svg />
}
